export const entityTypeEnum = {
  football_club: "Football Club",
  football_Club: "Football Club",
  football_academy: "Football Academy",
  federation_entity: "Football Entity",
  sponsor_brand: "Sponsor Brand",
  professional_training_entity: "Professional Training Entity",
  university: "University",
  School_or_university: "School or university",
  school: "School",
  other: "Other",
} as const;

export const entityTypes = [
  "football_club",
  "football_Club",
  "football_academy",
  "federation_entity",
  "sponsor_brand",
  "professional_training_entity",
  "university",
  "School_or_university",
  "school",
  "other",
] as const;
